import './styles/maintenance-template-details.scss'

import React      from 'react'
import PropTypes  from 'prop-types'
import uuid       from 'react-uuid'
import classnames from 'classnames'

import {
  Message,
  Button,
  Form,
} from 'semantic-ui-react'

import Loading        from '../components/Loading'
import IntegrationRow from './IntegrationRow'

import api from '../redux/api'

import { getFormattedError } from '../graphql/utils'

function createIntegration({ sender, receiver, dataType } = { sender: '', receiver: '', dataType: '' }) {
  return {
    id: uuid(),
    sender,
    receiver,
    dataType,
  }
}

export default class MaintenanceTemplateDetails extends React.Component {
  static propTypes = {
    match:   PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  }

  state = {
    error:    null,
    loading:  false,
    updating: false,

    id:           -1,
    name:         '',
    description:  '',
    integrations: []
  }

  isNew() {
    return this.props.match.params.id === 'new'
  }

  isComplete = () => {
    const hasName        = !!this.state.name
    const incompleteItem = this.state.integrations.find(({ sender, receiver, dataType }) => !sender || !receiver || !dataType)

    return hasName && !incompleteItem
  }

  componentDidMount() {
    const func = this.isNew()
      ? this.createNewTemapte
      : this.loadMaintenanceTemplateDetails
    func()
  }

  componentDidUpdate() {
    if (this.state.integrations.length === 0) {
      this.setState({ integrations: [createIntegration()] })
    }
  }

  createNewTemapte = () => {
    this.setState({ id: uuid(), integrations: [createIntegration()] })
  }

  loadMaintenanceTemplateDetails = () => {
    const { id } = this.props.match.params

    this.setState({ loading: true }, () => {
      api.loadMaitenanceTemplate({ templateId: id }).then((data) => {
        this.setState({
          loading:      false,
          id:           data.id,
          name:         data.name,
          description:  data.description,
          integrations: data.integrations.map(({ sender, receiver, dataType }) => {
            return createIntegration({
              sender:   sender.id,
              receiver: receiver.id,
              dataType: dataType.id,
            })
          }),
        })
      }).catch((error) => {
        this.setState({ loading: false, data: null, error: getFormattedError(error) })
      })
    })
  }

  handleNameDescriptionChange = (e, { name, value }) => {
    this.setState({ [name]: value })
  }

  handleCancel = () => {
    this.props.history.push('/maintenance-templates')
  }

  handleConfirm = () => {
    const template = {
      id:           this.state.id,
      name:         this.state.name,
      description:  this.state.description,
      integrations: this.state.integrations.slice(),
    }

    this.setState({ updating: true }, () => {
      api.addMaintenanceTemplate({ template }).then(() => {
        setTimeout(this.handleCancel, 2000) // Give time to read side sync...
      }).catch((error) => {
        this.setState({ error: getFormattedError(error), updating: false })
      })
    })
  }

  handleIntegrationChange = (integrationId, change) => {
    const integrations = this.state.integrations.slice()

    const integration  = integrations.find(({ id }) => id === integrationId)
    const index        = integrations.indexOf(integration)

    if (index >= 0) {
      integrations[index] = { ...integration, ...change }
      this.setState({ integrations })
    }
  }

  handleIntegrationAppend = (integrationId) => {
    const integrations = this.state.integrations.slice()

    const integration  = integrations.find(({ id }) => id === integrationId)
    const index        = integrations.indexOf(integration)

    if (index >= 0) {
      integrations.splice(index + 1, 0, createIntegration())
      this.setState({ integrations })
    }
  }

  handleIntegrationDelete = (integrationId) => {
    const integrations = this.state.integrations.slice()

    const integration  = integrations.find(({ id }) => id === integrationId)
    const index        = integrations.indexOf(integration)

    if (index >= 0) {
      integrations.splice(index, 1)
      this.setState({ integrations })
    }
  }

  render() {
    const { error, loading, updating, name, description, integrations } = this.state

    if (loading) return <Loading/>

    const isNew      = this.isNew()
    const isComplete = this.isComplete()

    const glassPaneClass = classnames('glass-pane', { updating })    

    return (
      <div className="maintenance-template-details">
        <div className={glassPaneClass} />
        {
          error && (
            <div className="section">
              <Message negative>
                <Message.Header>Error:</Message.Header>
                <p>{ error }</p>
              </Message>
            </div>
          )
        }
        {
          !isNew && (
            <div className="section">
              <Message>
                <Message.Header>Note:</Message.Header>
                <p>The changes in the template will only affect new Maintenances created off of the template</p>
              </Message>
            </div>
          )
        }
        <Form>
          <div className="section">
            <Form.Field>
              <label>Name</label>
              <Form.Input
                placeholder='Name'
                name='name'
                value={name}
                onChange={this.handleNameDescriptionChange}
              />
            </Form.Field>
            <Form.Field>
              <label>Description</label>
              <Form.Input
                placeholder='Description'
                name='description'
                value={description}
                onChange={this.handleNameDescriptionChange}
              />
            </Form.Field>
          </div>

          <div className="section">
            {
              integrations.map((integration) => {
                const onChange = (change) => this.handleIntegrationChange(integration.id, change)
                const onAppend = () => this.handleIntegrationAppend(integration.id)
                const onDelete = () => this.handleIntegrationDelete(integration.id)

                return <IntegrationRow
                  key={integration.id}
                  integration={integration}
                  onChange={onChange}
                  onAppend={onAppend}
                  onDelete={onDelete}
                />
              })
            }
          </div>

          <div className="actions">
            <Button onClick={this.handleCancel}>Cancel</Button>
            <Button onClick={this.handleConfirm} disabled={!isComplete} primary>OK</Button>
          </div>
        </Form>
      </div>
    )
  }
}
